import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client-service';
import { ApiNameList } from 'src/environments/api-name-list';

@Injectable()
export class ConfigDataService {
    public baseUrl = '';
    constructor(public httpClientService: HttpClientService) {
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    getConfigData(data): any {
        const requestObject = {
            data
        };
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getConfigData, requestObject);
    }
}
